import { Handler, HasOnSuccess, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    GetProductVariantChildrenApiV2Parameter,
} from "@insite/client-framework/Services/ProductServiceV2";
import { chain, PopulateApiParameter} from "@insite/client-framework/Store/Data/Products/Handlers/LoadVariantChildren";
import { ProductCollectionModel, ProductModel } from "@insite/client-framework/Types/ApiModels";

type Parameter = { productId: string } & HasOnSuccess<ProductModel[]>;
type Props = {
    apiParameter: GetProductVariantChildrenApiV2Parameter;
    apiResult: ProductCollectionModel;
};

type HandlerType = Handler<Parameter, Props>;

export const PopulateApiParameterExtension: HandlerType = props => {
    props.apiParameter = {
        productId: props.parameter.productId,
        pageSize: 500,
        expand: ["content", "documents", "specifications", "attributes", "badges", "properties"],
        includeAttributes: ["includeOnProduct"],
    };
};

replaceInChain(chain, PopulateApiParameter, PopulateApiParameterExtension);